<template>
  <div class="container d-flex flex-row">
    <div class="error-message">
      <h1>404</h1>
      <p>Page not found</p>
    </div>
  </div>
</template>
